import { ElementName, ElementType, Location, Module } from "./constants";

export interface OnboardingSetName {
  module?: string;
  name?: string;
  path?: any;
  [property: string]: any;
}

export interface OnboardingSetProfilePhoto {
  element_copy?: string;
  element_name: string;
  element_type: string;
  location: string;
  module: string;
  path?: any;
  [property: string]: any;
}

export interface OnboardingSetUsername {
  is_generated?: boolean;
  module?: string;
  path?: any;
  username?: string;
  [property: string]: any;
}

export interface OnboardingSetBirthday {
  age?: number;
  birthday?: string;
  module?: string;
  path?: any;
  [property: string]: any;
}

export function useOnboardingAnalytics() {
  const setBirthdayAnalytics = (date: Date) => {
    const birthday = date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    const today = new Date();
    const yearDiff = today.getFullYear() - date.getFullYear();
    const monthDiff = today.getMonth() - date.getMonth();
    const dayDiff = today.getDate() - date.getDate();

    let age = yearDiff;
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age = yearDiff - 1;
    }

    window.analytics?.track<OnboardingSetBirthday>(
      "Onboarding - Set Birthday",
      {
        module: Module.Onboarding,
        birthday,
        age,
      }
    );
  };

  const setNameAnalytics = (name: string) => {
    window.analytics?.track<OnboardingSetName>("Onboarding - Set Name", {
      module: Module.Onboarding,
      name,
    });
  };

  const setUsernameAnalytics = (username: string, isGenerated: boolean) => {
    window.analytics?.track<OnboardingSetUsername>(
      "Onboarding - Set Username",
      {
        module: Module.Onboarding,
        username,
        is_generated: isGenerated,
      }
    );
  };

  const setProfilePhotoAnalytics = (elementCopy: string) => {
    window.analytics?.track<OnboardingSetProfilePhoto>(
      "Onboarding - Set Profile Photo",
      {
        module: Module.Onboarding,
        location: Location.Onboarding,
        element_copy: elementCopy,
        element_name: ElementName.OnboardingSetProfilePhoto,
        element_type: ElementType.Button,
      }
    );
  };

  const onboardingErrorAnalytics = (message: string) => {
    window.analytics?.track("Onboarding - Error", {
      module: Module.Onboarding,
      location: Location.Onboarding,
      message,
    });
  };

  return {
    setBirthdayAnalytics,
    setNameAnalytics,
    setUsernameAnalytics,
    setProfilePhotoAnalytics,
    onboardingErrorAnalytics,
  };
}
